export const __DEVELOPMENT__ = import.meta.env.MODE === 'development';
export const __PRODUCTION__ = import.meta.env.MODE === 'production';
export const __TEST__ = import.meta.env.MODE === 'test';
export const __STAGING__ = import.meta.env.MODE === 'staging';
export const __DEBUG__ = import.meta.env.DEBUG === 'true';
